import { FuncKeywordDefinition } from "ajv";

const def: FuncKeywordDefinition = {
    keyword: "nfData",
    valid: true,
};

export default def;